/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import './store';
import {
  Component, Provide, Watch, Prop, Mixins,
} from 'vue-property-decorator';
import { Route } from 'vue-router';
import { namespace } from 'vuex-class';
import { Dialog as DialogVant } from 'vant';
import { Toast, Dialog, DialogEventNames } from '@hb/coffee';
import { throttle } from 'lodash';

import { RouterV2Enum } from '@/router/router-names';
import { livenessPop } from '@/components/liveness-pop';
import { LivenessProjectEnum, LivenessSceneEnum } from '@/enums/liveness-param';
import {
  ApplyChannelData,
  ApplyProductData,
  SubmitApplyResultData,
  SmsConfirmResult,
  LoanUsageOption,
  CalcPlanListData,
  OrderQueryRealTime,
  OrderCheck,
  ProductCapitalItem,
  RemoteContract,
  LoanApplyMarketReqType,
  ChannelDisableEnum,
  CardBindTypeEnum,
  EquityPathType,
  RouteMarketEnum,
} from '@/api/apply-product/types';


import type { ContractItem } from '@/ContractConfig';

import TradeKey from '@/components/trade-key-pop';
import RouterHelper from '@/shared/utils/routerHelper';
import { ResponseCodeEnum } from '@/enums/response-code';
import platform, { codeEnums } from '@/shared/utils/platform';
import store from '@/store';
import { local, session } from '@/shared/utils/storage';
import type { SelectCardInfo } from '@/api/cardBind/types';
import type { CouponRolePo } from '@/api/coupon/types';
import { SessionEnum } from '@/enums/session';
import SelectCardApi from '@/api/cardBind';
import PopupView from '@/components/popup-view';
import ProductCommodity, {
  ALIPAYMINI_COMMODITY,
  DUXIAOMAN_COMMODITY,
  HANGYIN_COMMODITY,
  NEWORAGE_COMMODITY,
  NEW_YINHE_COMMODITY,
  PPD_COMMODITY,
  SHENGBEI_COMMODITY,
  SUNING_COMMODITY,
  TIANCHENG_COMMODITY,
  TONGCHENG_COMMODITY,
  YINHE_COMMODITY,
  isNewYhChannel,
} from '@/shared/commodity';
import ContractApi from '@/api/contract';
import { RepaymentModel, RepayMentModelType, repayPlanModelType } from '@/po/ProductResult';
import { contractPage } from '@/components/contract';
import { getHomePath, HOME_ALL_VERSION_ROUTE_PATHS } from '@/router/utils';
import AlipayMixins from '@/mixins/alipay';
import ApplyBreakMixins from '@/mixins/apply-break';
import type { LoanAgreementPO, Commodity } from '@/api/contract/types';
import {
  closeWebView,
  nativeLocalGetData,
  nativeLocalRemoveData,
  nativeLocalSetData,
  openThirdPage,
} from '@/api/native/utils';
import { GoResultSceneType, SceneTypeEnum, SmsSceneType } from '@/enums/scene-type';
import { ContractEnum } from '@/enums/contract-type';
import FinanceBusiness from '@/mixins/finance-business';
import AbTest from '@/mixins/abTest';
import { isH5App } from '@/constant';
import {
  queryEvent, showAdvert, subscribeTCP, unsubscribeTCP,
} from '@/api/native/kongming';
import isSupportKongMingTCP from '@/shared/utils/isSupportKongMingTCP';
import isSupportNativeDataStorage from '@/shared/utils/isSupportNativeDataStorage';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import URLUtils from '@/shared/utils/URLUtils';
import router from '@/router';
import { loanOrderCheck, reportAgreementAgree } from '@/api/apply-product';
import { ubtSendError } from '@/shared/utils/ubt';
import { pickObjectProperty } from '@/shared/utils/pickObjectProperty';
import { popPageManager } from '@/shared/tools/popPageManager';
import { LocalEnum } from '@/enums/local';

import jumpToVerifyCredit, { checkBindCardNeedVerify } from '@/shared/verify-credit-controller';
import { OpenVerifyPageMode, VerifyQueryParamsTypeEnum, VerifySceneEnum } from '@/shared/verify-credit-controller/types';
import { supplyNeedConfig } from '@/api/userPersonalInfo';
import { clearNoExpectedNodeInPrerender, IS_PRERENDERING } from '@hb/coffee-prerender';
import { commonDispatchPreRender } from '@/shared/utils/prerenderHelper';
import { CAN_USE_NEW_WEBVIEW_FOR_JUMP } from '@/shared/utils/quickBindCard';
import { EquitySelectedEnum, PricingTypeEnum } from '@/enums/rights';
import { EventLoopNotifySceneEnum } from '@/api/tempAmount/types';
import type { FullAmountCouponType } from '@/views_v2/apply-product/types';
import { AutrakyProcessExpEnum, RightPackageTypeEnum } from '@/api/rights/types';

import type {
  BindCardContext,
  BindCardResult,
  H5BioCache,
  LoanBankCard,
  LoanConfigCity,
  PeriodOption,
  AntiFraudConfigType,
  LoanRightStateType,
  ValidateFunction,
  getCalRepayPlans,
  UserSceneConfig,
  StateType,
} from './types';

import {
  ReplanResultType,
  LoanGpsEnum,
  SpeedRightsType,
} from './types';

import {
  SuperMemberCardInstance,
} from './components/rights/super-member-card';


import { FormInfomation } from '../card-list/types';
import { checkAndHandleLocationPermission, checkIsOpenGPS } from '../pre-apply-choose/utils';

// cmpt
import TopNotice from './components/top-notice';
import MoneyInput from './components/money-input';
import SelectChannel, { resetSelectChannelRemindPopupControl } from './components/select-channel';
import SelectPeriod from './components/select-period';
import RepayPlan from './components/repay-plan';
import SelectBankcard from './components/select-bankcard';

import ZiyingBRightsTab from './components/rights/zhenxiang-card';
import {
  SessionStorageKeys,
  applyPorductIsBackFromRoutes,
  getBankCrucialInfo,
  getDoubleModeCommonUbtParams,
  getSnapQuotaAmount,
} from './product';

import { destroyInstance, doAllinpayAuth } from './components/rights/bind-card-pop/show';
import {
  RightDataDialog, formatZhenXiangCardParams,
} from './components/rights/zhenxiang-card/utils';
import {
  checkEquityValue, checkPackageType, checkParamsMatch,
} from './components/rights/zhenxiang-card/check';

import { RightTipsDialogActionEnum, RightTipsDialogSceneEnum } from './components/rights/zhenxiang-card/enum';
import { dispatchNotBuyZhenxiangCardEvent, getPricingTypeByProductId, updateClickedSubmitProductIds } from './utils';
import {
  AutarkyLimitReturnType, checkAutarkyLimit, ClickTypeEnum, showAutarkyLimitDialog,
} from './components/rights/zhenxiang-card/checkAutarkyLimit';
import { destroyAutarkyRetainRightsPopup } from './components/rights/zhenxiang-card/hello-app/autarkyRetainRightsTest/popupService';
import { destroyCouponDiscountPopup } from './components/rights/zhenxiang-card/hello-app/autarkyRetainRightsTest/couponDiscountPopupService';
// 主题css样式引入
import './apply.theme.blue.scss';

/** async components */
/** 超级会员购买卡片 */
const SuperMemberCard = () => import(/* webpackChunkName: "right-card" */ './components/rights/super-member-card') as any;
/** 短信验证码弹窗 */
const SMSDialog = () => import(
  /* webpackChunkName: "sms-dialog" */'@/components/smsDailog'
) as any;
/** 新版提现协议弹窗 */
const WithdrawalPopUp = () => import(
  /* webpackChunkName: "withdrawal-popup" */'@/views_v2/apply-product/components/withdrawal-popup'
) as any;
/** 多资方提现协议弹窗 */
const MultiCapital = () => import(
  /* webpackChunkName: "multi-capital" */'@/views_v2/apply-product/components/multi-capital'
) as any;
const AdvApplyCornerMark = () => import(
  /* webpackChunkName: "adv-apply-corner-mark" */'@/components/adv-components/adv-apply-corner-mark'
) as any;
const AdvApplyPopup = () => import(
  /* webpackChunkName: "adv-apply-popup" */'@/components/adv-components/adv-apply-popup'
) as any;
const ForcedPopup = () => import(
  /* webpackChunkName: "forced-popup" */'@/views_v2/apply-product/components/forced-popup'
) as any;
const CountdownPopup = () => import(
  /* webpackChunkName: "countdown-popup" */'@/views_v2/apply-product/components/countdown-popup'
) as any;
const BreakApplyPopup = () => import(
  /* webpackChunkName: "break-apply-popup" */'@/views_v2/apply-product/components/break-apply-popup'
) as any;
const FraudPopUp = () => import(
  /* webpackChunkName: "fraud-popup" */'@/views_v2/apply-product/components/fraud-popup'
) as any;
const SelectCoupon = () => import(
  /* webpackChunkName: "select-coupon" */'@/views_v2/apply-product/components/select-coupon'
) as any;
const SelectAlipay = () => import(
  /* webpackChunkName: "select-alipay" */'@/views_v2/apply-product/components/select-alipay'
) as any;
const RepaymentRate = () => import(
  /* webpackChunkName: "repayment-rate" */'@/views_v2/apply-product/components/repayment-rate'
) as any;

const RepayChoice = () => import(
  /* webpackChunkName: "repay-choice" */'@/views_v2/apply-product/components/repay-choice/index'
) as any;

/** 退出nps调研挽留弹窗 */
const AdvApplyBackPopup = () => import(
  /* webpackChunkName: "async-apply-back-pop" */ '@/views_v2/apply-product/components/apply-back-pop'
) as any;

/** 满额提现券弹窗 */
const FullAmountPop = () => import(
  /* webpackChunkName: "full-amount-pop" */ '@/views_v2/apply-product/components/full-amount-pop/index.vue'
) as any;

/** 提额成功弹窗 */
const TempAmountSuccessPopup = () => import(
  /* webpackChunkName: "temp-amount-success-popup" */ '@/views_v2/apply-product/components/temp-amount-success-popup/index.vue'
) as any;

/** 优惠模块 */
const DiscountModule = () => import(
  /* webpackChunkName: "discount-module" */ '@/views_v2/apply-product/components/discount-module/index.vue'
) as any;

const style = require('./index.module.scss') as Dictionary;

const ApplyProductStore = namespace('applyProduct');
const HomeStore = namespace('home');
const LoanRightStore = namespace('loanRight');
const TempAmountStore = namespace('tempAmount');

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);
@Component
export default class ApplyProduct extends Mixins(
  AbTest,
  AlipayMixins,
  ApplyBreakMixins,
  FinanceBusiness,
) {
  // 默认选中的渠道产品id
  @Prop({
    type: String,
    required: false,
  })
  private readonly commodityId!: string;

  // 是否 h5活体回跳
  @Prop({
    type: Boolean,
    required: false,
  })
  private readonly h5Bio!: boolean;

  // 是否 h5活体回跳
  @Prop({
    type: String,
    required: false,
  })
  private readonly sceneType!: LivenessSceneEnum;

  // 默认选中的优惠券 id
  @Prop({
    type: String,
    required: false,
  })
  private readonly couponId!: string;

  // 默认选中的渠道优惠券 id
  @Prop({
    type: String,
    required: false,
  })
  private readonly externalCouponId!: string;

  @ApplyProductStore.State notice!: string;

  @ApplyProductStore.State checkType!: string;

  @ApplyProductStore.State channelList!: ApplyChannelData[];

  @ApplyProductStore.State channel!: ApplyChannelData | undefined;

  @ApplyProductStore.State selectRightInCapital!: ProductCapitalItem;

  /** TODO: 待评估是否可以删除  */
  @ApplyProductStore.State sceneConfig!: UserSceneConfig;

  @ApplyProductStore.State contracts!: (ContractItem | RemoteContract | Commodity)[];

  @ApplyProductStore.State payType!: CardBindTypeEnum;

  @ApplyProductStore.State product!: ApplyProductData | undefined;

  @ApplyProductStore.State needTradePasswd!: boolean;

  @ApplyProductStore.State submitResult!: SubmitApplyResultData;

  @ApplyProductStore.State loanConfigCity: LoanConfigCity | undefined;

  @ApplyProductStore.State iSalipaySignSuccess!: boolean;

  @ApplyProductStore.State bankCard!: LoanBankCard | undefined;

  @ApplyProductStore.State amount!: string;

  @ApplyProductStore.State maxAmount!: string;

  @ApplyProductStore.State period!: PeriodOption | undefined;

  @ApplyProductStore.State usage!: LoanUsageOption | undefined;

  @ApplyProductStore.State repaymentModel!: string;

  @ApplyProductStore.State couponList!: CouponRolePo[];

  @ApplyProductStore.State planListData!: CalcPlanListData;

  @ApplyProductStore.State loadingCalcRepayPlans!: boolean;

  @ApplyProductStore.State calcFailedMsg!: string;

  @ApplyProductStore.State tradePasswdToken!: string

  @ApplyProductStore.State coupon!: CouponRolePo;

  @ApplyProductStore.State smsCode!: string

  @ApplyProductStore.State lastApplyResult!: string

  @ApplyProductStore.State queryRealTimeStatus!: OrderQueryRealTime

  @ApplyProductStore.State isBankCardUsed!: {
    cardNo: string;
    isBind: boolean;
    productId: number;
  };

  @ApplyProductStore.State isCouponVisible!: boolean;

  @ApplyProductStore.State checkId!: string

  @ApplyProductStore.State orderCheckListDxm!: OrderCheck

  @ApplyProductStore.State brokenProductId!: string

  @ApplyProductStore.State isVisibleLoading!: boolean;

  @ApplyProductStore.State antiFraudConfig!: AntiFraudConfigType | null;

  @ApplyProductStore.State totalAvailableAmount!: number;

  @ApplyProductStore.State channelExtendObj!: Record<string, unknown>;

  @ApplyProductStore.State autrakyProcessExpRes!: AutrakyProcessExpEnum;

  @LoanRightStore.State rightParams!: LoanRightStateType['rightParams'];

  @ApplyProductStore.State is24NeedRightAndNormalIs36!: boolean;

  @ApplyProductStore.State autrakyZhenxiangCardState!: StateType['autrakyZhenxiangCardState'];

  @ApplyProductStore.Getter needBuyRight!: boolean;

  @ApplyProductStore.Getter needBuyZhenxiangMember!: boolean;

  @ApplyProductStore.Getter needBuyZhenxiangCard!: boolean;

  @ApplyProductStore.Getter currentRepayType!: string;

  @ApplyProductStore.Getter isDoublePassagewayPattern!: boolean;

  @ApplyProductStore.Getter isDoublePassagewayPattern24RightsAndPure24!: boolean;

  @ApplyProductStore.Getter isCouponLimitExperiment!: boolean;

  @LoanRightStore.Getter isNeedRightCapitalSinglePassage!: boolean;

  @HomeStore.Getter isExperimentAB!: boolean;

  @ApplyProductStore.Action $resetState!: () => void;

  @ApplyProductStore.Action('$updateState') updateApplyProductState!: (data: Dictionary) => void;

  @ApplyProductStore.Action checkTempAmountEntryShow!: () => Promise<void>;

  @ApplyProductStore.Action resetTempAmountEntryState!: () => void;

  @LoanRightStore.State isCountingDownFinished!: LoanRightStateType['isCountingDownFinished'];

  @LoanRightStore.State recordCountDownTime!: LoanRightStateType['recordCountDownTime'];

  @LoanRightStore.State showSpeed!: LoanRightStateType['showSpeed'];

  @LoanRightStore.Action('$updateState') updateLoanRightState!: (data: Dictionary) => void;

  @ApplyProductStore.Action initUriQueryContext!: () => void;

  @ApplyProductStore.Action sendApplySms!: (smsSceneType: SmsSceneType) => Promise<void>;

  @ApplyProductStore.Action getAntiFraudConfig!: () => Promise<void>;

  @ApplyProductStore.Action getContracts!: (constractItem: LoanAgreementPO) => Promise<void>;

  @ApplyProductStore.Action getAutarkyAgreements!: () => Promise<void>;

  @ApplyProductStore.Action multiCapitalContracts!: () => Promise<void>;

  @ApplyProductStore.Action calcRepayPlans!: (payload: getCalRepayPlans) => Promise<void>;

  @ApplyProductStore.Action getChannelList!: (payload: {
    productId: string;
  }) => Promise<void>;

  @ApplyProductStore.Action submitOrderApply!: (payload: {
    smsCode: string;
    defaultCouponId: string;
    defaultExternalCouponId?: string;
    lastApplyResult?: boolean;
    insuranceRelationNo?: string;
    creditApplyId?: string;
    capitalCode?: string;
    allinPayCheck?: boolean;
    loanApplyMarketReq?: LoanApplyMarketReqType
  }) => Promise<void>;

  @ApplyProductStore.Action selectApplyChannel!: (payload: {
    channel: ApplyChannelData;
  }) => Promise<void>;

  @ApplyProductStore.Action confirmApplySms!: (payload: {
    smsCode: string;
    smsSceneType: SmsSceneType
  }) => Promise<SmsConfirmResult>;

  // 定位配置
  @ApplyProductStore.Action getConfigCity!: (payload: {
    commodityId: string;
  }) => Promise<void>;

  // 查询签约状态-6000
  @ApplyProductStore.Action checkAlipayStatus!: () => Promise<void>;

  // 查询该卡在渠道方银行列表是否绑定
  @ApplyProductStore.Action takeBankCardIsUsed!: (payload: {
    userBankCardId: string;
    productId: string;
  }) => Promise<void>;

  // 度小满二次提现
  @ApplyProductStore.Action orderApply!: () => Promise<void>;

  // 度小满订单终止
  @ApplyProductStore.Action orderUpdateFailed!: () => Promise<void>;

  @ApplyProductStore.Action getCouponList!: () => Promise<void>;

  @ApplyProductStore.Action confirmFullAmount!: () => void;

  @ApplyProductStore.Action getApplyOptimizeExperimentRes!: () => Promise<void>;

  @ApplyProductStore.State h5BioSuc!: boolean;

  @ApplyProductStore.State showHowToRepay!: boolean;

  @ApplyProductStore.State repayOnSchedule!: boolean;

  @ApplyProductStore.Getter isMarketingAmountExperiment!: boolean;

  @ApplyProductStore.Getter isDiscountModuleExperiment!: boolean;

  @ApplyProductStore.Getter showFullAmountCouponTag!: boolean;

  @ApplyProductStore.State fullAmountCoupon!: FullAmountCouponType;

  @TempAmountStore.Action commonPollingNotifyIssued!: (payload: {
    loopSceneList: EventLoopNotifySceneEnum[];
  }) => Promise<void>;

  @TempAmountStore.Action updateSuspendFeelTempAmount!: (params: Dictionary) => Promise<void>;

  @ApplyProductStore.Action getPeriodData!: (currentAmount: string) => Promise<void>;

  /** 权益勾选提示是否展示 */
  private rightscheckTipsShow = false;

  // 是否显示短信验证码弹窗
  private showSmsDialog = false;

  // 是否需要重置数据
  private shouldResetState = false;

  /** 提现用户协议信息备份，为了解决第一个渠道不为银河时，get数据无法动态从session获取的问题 */
  private loanContractFormBak: LoanAgreementPO | Dictionary = {};

  private unsubscribeTCPPageId = '';

  /** 一键绑卡回跳的返回结果 */
  private quickBindCardResult: BindCardResult | null = null;

  private get getInsuranceRelationNo() {
    // 解决众安投保回调的参数拼在 # 之后，this.$route.query无法获取到该参数
    const { relationNo = '' } = URLUtils.getQueryMap();
    return this.$route.query.relationNo || relationNo || '';
  }

  // 是否支持重新发送短信验证码(TODO: 如何更好的抽象化，避免硬编码)
  private get canResendSms(): boolean {
    // 中断订单 支持重新下发短信验证码
    if (this.smsSceneType === SmsSceneType.BROKEN) {
      const id = this.brokenProductId ? this.brokenProductId : this.commodityIdChannel;
      return !![
        NEWORAGE_COMMODITY, // 后置短验
        // JUZI_COMMODITY,//后置短验
      ].includes(id);
    }
    return !!(
      this.channel
      && [
        SUNING_COMMODITY, // 苏宁渠道
        SHENGBEI_COMMODITY, // 省呗渠道
        PPD_COMMODITY, // 拍拍贷,
        DUXIAOMAN_COMMODITY,
      ].includes(this.commodityIdChannel)
    );
  }

  // 默认选中的优惠券  TODO: 待评估是否可以删除, 目前看下来 是可以删掉
  private get getDefaultCoupon(): CouponRolePo | undefined {
    return this.isCouponVisible && this.couponList.length > 0
      ? this.couponList.find((item) => item.isFirst === true)
      : undefined;
  }

  // 电子合同展示数据
  private get getContractInfo() {
    return [
      HANGYIN_COMMODITY,
      YINHE_COMMODITY,
      NEW_YINHE_COMMODITY,
      ALIPAYMINI_COMMODITY,
    ].includes(this.commodityIdChannel);
  }

  private get commodityIdChannel() {
    return (this.channel && this.channel.productId) || '';
  }

  /** 选中渠道名称（资方名称） */
  private get commodityNameChannel() {
    return (this.channel && this.channel.productName) || '';
  }

  // 自营 B 渠道 资方code
  private get capitalCode() {
    return (this.channel && this.channel.capitalCode) || '';
  }

  /** 获取渠道列表 productIdList， 供查询中断订单接口使用 */
  private get channelProductIdList() {
    if (this.channelList.length > 0) {
      const arr: string[] = [];
      this.channelList.forEach((e) => {
        arr.push(e.productId);
      });
      return arr;
    }
    return [];
  }

  private get isYhProductId() {
    return [YINHE_COMMODITY].indexOf(this.commodityIdChannel) >= 0;
  }

  // 是否是银河支付宝小程序
  private get isAlipayMiniCommodity() {
    return [ALIPAYMINI_COMMODITY].indexOf(this.commodityIdChannel) >= 0;
  }

  private get loanContractForm() {
    return this.loanContractFormBak;
  }

  // 度小满-交易鉴权强弹协议
  private get forceReadContract() {
    return [
      DUXIAOMAN_COMMODITY,
    ].indexOf(this.commodityIdChannel) >= 0;
  }

  // 甜橙金融投保--渠道已无该模式
  private get isTianchengProductId() {
    return [
      TIANCHENG_COMMODITY,
      ProductCommodity.ZHONGAN_LOAN,
    ].indexOf(this.commodityIdChannel) >= 0;
  }

  // 度小满-是否显示未完成订单弹窗
  private get isVisibleOutstandingOrdersPopup(): boolean {
    return this.orderCheckListDxm && this.orderCheckListDxm.popWindow;
  }

  // 离开的时候是否显示挽留弹窗模块
  private isBackDialogVisible = false;

  // 表单验证，需要强制验证的数据以及验证规则
  private formValidators: ValidateFunction[] = [];

  // 判断当前卡是否最新
  private cardBankList: SelectCardInfo[] = [];

  private timer: unknown = null

  /** 新版统一提现弹窗 */
  private isVisiblePopUp = false;

  /** 显示多资方提现弹窗协议 */
  private showMultiCapital = false;

  /** 诈骗弹窗 */
  private isVisibleFraudPopUp = false;

  /** 一次生命周期仅展示 */
  private hasShownFraudPopUp = false;

  private timerNumId: unknown = null

  private timeLationNo: unknown = null

  private currentVisiblePopup = false

  private isVisibleForcePopup = false

  private brokenPop = false;

  // 标记当前短信校验的场景，用于区分短验的接口
  private smsSceneType: SmsSceneType = SmsSceneType.DEFAULT;

  // 回溯码
  private relationNo = '';

  /** 孔明 客户端事件轮询 */
  private kongmingTimer: NodeJS.Timer | null = null;

  /** 是否需要显示挽留弹窗,默认不显示,根据组件中抛出的值来控制 */
  private showBackPop = false;

  private needShowBackPop = true;

  /** h5活体回跳场景，权益缓存数据 */
  public h5BioLoanApplyMarketReq: LoanApplyMarketReqType | undefined = undefined;

  beforeRouteEnter(_: Route, from: Route, next: () => void): void {
    try {
      /** 若是back返回到提现页场景，则检查临额下发状态 */
      if (applyPorductIsBackFromRoutes.includes(from.path)) {
        store.dispatch('tempAmount/commonPollingNotifyIssued', {
          loopSceneList: [EventLoopNotifySceneEnum.TEMP_AMOUNT],
        });
      }
    } catch (err) {
      ubtSendError(err as Error);
    }

    next();
  }

  // 度小满监听未完成订单
  @Watch('orderCheckListDxm', { immediate: true })
  private async onChange(orderCheckListDxm: OrderCheck) {
    // 度小满是否有存在未完成订单
    if (orderCheckListDxm && orderCheckListDxm.popWindow && orderCheckListDxm.contractType) {
      await this.getContractLoan(
        this.loanContractForm as LoanAgreementPO,
        orderCheckListDxm.contractType,
      );
      this.isVisibleForcePopup = true;
    }
  }

  @Provide()
  private registValidator(validator: ValidateFunction) {
    this.formValidators.push(validator);
  }

  private created() {
    this.quickBindCardResult = session.get(SessionStorageKeys.BACK_QUICK_BIND__FINAL_RESULT);

    // 获取提现页面优化实验结果
    this.getApplyOptimizeExperimentRes();
  }

  // 返回提现挽留弹窗-下次再说  TODO: 待评估是否可以收拢到组件内部
  private async onCancelWithdraw() {
    this.$ubtPageButton('finance_applyProduct_backDialog_cancel');
    DialogVant.close();
    Dialog.close();
    await this.$nextTick();
    this.$router.go(-1);
  }

  // 返回提现挽留弹窗-继续提现 TODO: 待评估是否可以收拢到组件内部
  private onConfirmWithdraw() {
    this.isBackDialogVisible = false;
    this.$ubtPageButton('finance_applyProduct_backDialog_confirm');
  }

  /** 支付宝签约场景 */
  private get isAlipayType() {
    return this.payType === CardBindTypeEnum.ALIPAY;
  }

  private get PageId(): string {
    const { pageId } = this.$route.meta;
    if (pageId) {
      return pageId as string;
    }
    return '';
  }

  private get showRepayChoice(): boolean {
    /** 修复切换还款期限时，"还款方式"-因接口请求时planListData无数据，模块展示抖动的问题 */
    if (this.showHowToRepay && (this.planListData || this.loadingCalcRepayPlans)) {
      this.$ubtModuleExposeNew('finance_loan_apply_repayMode', {});
      return true;
    }
    return false;
  }

  /** 获取 h5活体 本地存储数据 */
  private getCacheAfterH5Bio() {
  // h5活体场景
    const cacheData = (session.get(SessionStorageKeys.H5_BIO_DATA) || {}) as H5BioCache;

    this.updateApplyProductState({
      h5BioSuc: true, // h5活体成功以后 值取 getH5BioData
      ...cacheData,
      /** 未绑卡 + 未活体的场景，绑卡页会更新store的bankCard */
      bankCard: cacheData.bankCard || this.bankCard,
    });

    return cacheData;
  }

  private setCacheBeforeH5Bio() {
    if (platform.isDingTalk || isH5App) {
      /** 活体之前，先更新设置权益相关参数，在缓存到session中 */
      this.h5BioLoanApplyMarketReq = this.getCurrentRightParams();

      // 活体之前，存储本地store 数据到localstorage
      session.set(SessionStorageKeys.H5_BIO_DATA, pickObjectProperty(this, [
        'amount',
        'maxAmount',
        'period',
        'usage',
        'tradePasswdToken',
        'channel',
        'bankCard',
        'coupon',
        'checkType',
        'planListData',
        'checkId',
        'repaymentModel',
        'product',
        'isVisibleLoading',
        'selectRightInCapital',
        'contracts',
        'repayOnSchedule',
        'totalAvailableAmount',
        'channelExtendObj',
        'recordCountDownTime',
        'h5BioLoanApplyMarketReq',
      ]));
    }
  }

  private setCacheBeforeBindCard() {
    /** 普通绑卡-session生命周期可支持，设置back返回路由 */
    session.set(SessionEnum.toBindCard, {
      from: 'product',
      back: this.$route.fullPath,
      commodityId: this.channel && this.channel.productId,
    });

    /**
     * 一键绑卡-进入前的数据准备：
     * 哈啰App端内使用新开webview，数据状态不用缓存、恢复
     * H5端内使用location.href外跳，数据状态需要缓存、恢复
     */
    if (!CAN_USE_NEW_WEBVIEW_FOR_JUMP) {
      const quickBindCardContext = pickObjectProperty(this, [
        'amount',
        'maxAmount',
        'period',
        'usage',
        'tradePasswdToken',
        'channelList',
        'channel',
        'bankCard',
        'coupon',
        'checkType',
        'planListData',
        'checkId',
        'repaymentModel',
        'product',
        'isVisibleLoading',
        'selectRightInCapital',
        'contracts',
        'repayOnSchedule',
        'totalAvailableAmount',
        'recordCountDownTime',
      ]);

      local.set(LocalEnum.quickBindCard, {
        fromHistoryLength: window.history.length,
        quickBindCardContext,
      });
    }
  }

  private getCacheAfterBindCard(): boolean {
    const beforeContext = (local.get(LocalEnum.quickBindCard) || {}) as BindCardContext;
    const bindResult = (this.quickBindCardResult || {}) as BindCardResult;
    let handleRes = false;

    if (beforeContext && beforeContext.quickBindCardContext) {
      this.updateApplyProductState({
        ...beforeContext.quickBindCardContext,
        ...bindResult,
      });
      handleRes = true;

      /** 清空local缓存数据 */
      local.set(LocalEnum.quickBindCard, null);
    } else {
      ubtSendError('No Found Bind Card Context In Session');
    }

    return handleRes;
  }

  private handleBeforeGoCardList() {
    this.setCacheBeforeBindCard();
  }

  private render() {
    return (
      <div class={style.applyProduct}>
        <div class={style.pageContent}>
          {/* TODO: 顶部提示 */}
          <TopNotice />
          <MoneyInput />
          {/* 提现页面优化实验非实验组维持原位置 */}
          <SelectChannel
            position="top"
          />
          {(this.isMarketingAmountExperiment || this.isDiscountModuleExperiment) && (
            <DiscountModule />
          )}
          {this.showRepayChoice && <RepayChoice />}
          {/* 提现页面优化实验更新表单项文案、样式 */}
          <SelectPeriod />
          <RepayPlan />
          {/* 提现页面优化实验将选择渠道改为列表形式，点击后浮窗切换 */}
          <SelectChannel
            position="form"
          />
          {(!this.isAlipayType) && (
            <SelectBankcard
              ref="selectBankcardRef"
              quickBindCardResult={this.quickBindCardResult}
              onHandleBeforeGoCardList={() => this.handleBeforeGoCardList()}
            />
          )}
          {/* 营销潜力额度对照组不变 */}
          {!(this.isMarketingAmountExperiment || this.isDiscountModuleExperiment) && (
            <SelectCoupon />
          )}
          {(this.isYhProductId || this.isAlipayType) && (
            <SelectAlipay />
          )}
          <RepaymentRate />
          {this.needBuyRight
            && <ZiyingBRightsTab
              v-model={this.rightscheckTipsShow}
              h5Bio={this.h5Bio}
              quickBindCardResult={this.quickBindCardResult}
              pricingType={getPricingTypeByProductId(this.channel?.productId)}
              ref="ziyingbRightsTab"
              onSubmitClick={this.onSubmitClick.bind(this)}
              onRightTabChange={this.onRightTabChange.bind(this)}
            />}
        </div>

        <AdvApplyPopup
          commodityId={this.commodityIdChannel}
          sourceId={this.channel && this.channel.sourceId}
        />

        {/* 新版本提现协议弹窗 不能加 this.isVisiblePopUp 条件判断，会影响后面的 watch方法，导致协议不会展示 */}
         <WithdrawalPopUp
          v-model={this.isVisiblePopUp}
          onclose={this.onClosedPopup.bind(this)}
          onConfirm={this.onThrottleConfirmApplyContract}
        />


        {/* 多资方提现协议弹窗 */}
        <MultiCapital
          v-model={this.showMultiCapital}
          onclose={this.onClosedPopup.bind(this)}
          onConfirm={this.onThrottleConfirmApplyContract}
        />

        {/* 提现挽回弹窗 */}
        <AdvApplyBackPopup
          showPop={this.isBackDialogVisible}
          onback-pop-load={this.onBackPopLoad.bind(this)}
          onCancel={this.onCancelWithdraw.bind(this)}
          onConfirm={this.onConfirmWithdraw.bind(this)}
        />

        <FullAmountPop
          ref="fullAmountPopRef"
          amount={this.fullAmountCoupon?.amount}
          showFullAmountCouponTag={this.showFullAmountCouponTag}
          commodityId={this.commodityIdChannel}
          onConfirm={this.confirmFullAmount.bind(this)}
        />

        {/* 提额成功弹窗 */}
        <TempAmountSuccessPopup />

        {this.showSmsDialog && (
          <SMSDialog
            hasResend={this.canResendSms}
            productId={this.commodityIdChannel}
            onclose={this.hideSmsDialog.bind(this)}
            onsendSms={this.onSendApplySms.bind(this)}
            onsubmit={this.onSubmitSmsCode.bind(this)}
          />
        )}

        <FraudPopUp
          v-model={this.isVisibleFraudPopUp}
          onCancel={this.onClosedFraudPopup.bind(this)}
          onConfirm={this.onFraudConfirm.bind(this)}
          onChange={this.onChangeFraudState.bind(this)}
        />

        <BreakApplyPopup
          v-model={this.brokenPop}
          onclose={this.onClosedPopup.bind(this, SmsSceneType.BROKEN)}
          onConfirm={this.onConfirmSms.bind(this)}
          oncancel={this.onCancelApply.bind(this, SmsSceneType.BROKEN)}
        />

        {
          this.currentVisiblePopup && (
            <CountdownPopup
              v-model={this.currentVisiblePopup}
              onapply={this.submitResult && this.submitResult.loanWait
                ? this.getOrderQueryRealTime.bind(this) : this.onSubmitOrderApply.bind(this)} />)
        }

        {
          this.isVisibleForcePopup
          && <ForcedPopup
            v-model={this.isVisibleForcePopup}
            onconfirmApply={this.onForceReadBtn.bind(this)}
            onconfirmApplyDxm={this.onDxmOrderApply.bind(this)}
            oncancel={this.onCancelApply.bind(this)}
          />
        }

        <div class={style.footer} >
          {
            // 24+单通道普通通道切换到轻资产场景，无需展示会员卡片
            !this.is24NeedRightAndNormalIs36 && (
              <SuperMemberCard productId={this.commodityIdChannel} capitalCode={this.capitalCode} ref="superMemberCard"></SuperMemberCard>
            )
          }
          <div class={style.submitButtonWrapper}>
            <div
              class={[style.submitButton, IS_PRERENDERING && style.placeholder]}
              onClick={this.onSubmitClick.bind(this)}>
              提交
              <AdvApplyCornerMark />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 度小满实时查询申请
  private async getOrderQueryRealTime() {
    this.currentVisiblePopup = false;
    if (
      this.queryRealTimeStatus
      && this.queryRealTimeStatus.contractAdd
      && this.queryRealTimeStatus.contractType
    ) {
      await this.getContractLoan(
        this.loanContractForm as LoanAgreementPO,
        this.queryRealTimeStatus.contractType,
      );
      // 第二次强弹协议
      this.isVisibleForcePopup = true;
    } else {
      const loanOrderId = this.submitResult && this.submitResult.loanOrderId;
      this.goResultPage(loanOrderId);
    }
  }

  // 度小满-第二次提现
  private onDxmOrderApply() {
    const loanOrderId = (
      (this.submitResult && this.submitResult.loanOrderId)
      || (this.orderCheckListDxm && this.orderCheckListDxm.loanOrderId)
    ) || '';
    this.orderApply().then(() => {
      this.goResultPage(loanOrderId);
    });
  }

  /** 终止提现 */
  private async onCancelApply(type?: SmsSceneType) {
    // 桔多多中断弹窗
    if (type) {
      this.$ubtPageButton(
        'finance_click_ShortMessage_giveUp',
        'commodityId',
        this.commodityIdChannel,
      );
      await this.orderUpdateFailed();
      // 取消订单成功以后 再关闭弹窗
      this.onClosedPopup(type);
    } else {
      // 度小满场景 终止提现
      await this.orderUpdateFailed();
    }
  }

  private onClosedPopup(type?: SmsSceneType) {
    if (type) {
      this.updateApplyProductState({
        brokenProductId: '', // 中断弹窗关闭时，清空中断渠道id
      });
      this.brokenPop = false;
    }
    this.isVisiblePopUp = false;
    this.showMultiCapital = false;
  }

  private onConfirmSms() {
    this.showSmsDialog = true;
    // 中断订单弹窗 确认按钮点击时，设置短验弹窗类型为 broken
    this.smsSceneType = SmsSceneType.BROKEN;
  }

  /** 银行卡已绑定，但是卡列表未绑定，重新绑定 */
  private onBankCardBindDialogShow() {
    Dialog.alert({
      title: '温馨提示',
      message: '很抱歉！当前银行卡已失效，请重新绑定',
      confirmButtonText: '重新绑定',
      closeable: false,
      onEvent: (eventName: DialogEventNames) => {
        if (eventName === 'open') {
          this.$ubtPageButton('finance.withdrawalApplication.cardInvalid');
        }
      },
    }).then(() => {
      this.$ubtPageButton('finance.withdrawalApplication.cardInvalid.rebind');
      /** 进入银行绑卡前的数据缓存 && back返回设置 */
      this.handleBeforeGoCardList();
      this.$router.push({
        path: RouterV2Enum.cardBind,
        query: {
          from: 'product',
          commodityId: String(this.commodityIdChannel),
          userBankId: (this.bankCard && this.bankCard.bankId) || '',
          capitalCode: this.capitalCode,
          isPreCredit: String(this.channel?.preCredit),
          ocrAfterLoan: String(this.channel?.ocrAfterLoan),
        },
      });
    });
  }

  /** 银行卡未绑定，更换或者重新选择银行卡 */
  private onBankCardSelectDialogShow() {
    Dialog.alert({
      title: '温馨提示',
      message: `很抱歉！当前${this.bankCard ? this.bankCard.bankName : ''}银行卡(尾号${this.bankCard
        ? this.bankCard.bankNo.substr(-4) : ''})已不可用，请重新绑卡或更换银行卡`,
      confirmButtonText: '重新选择银行卡',
      closeable: false,
      onEvent: (eventName: DialogEventNames) => {
        if (eventName === 'open') {
          this.$ubtPageButton('finance.withdrawalApplication.cardNotAvailable');
        }
      },
    }).then(() => {
      this.$ubtPageButton(
        'finance.withdrawalApplication.cardNotAvailable.reselect',
      );
      /** 进入银行绑卡前的数据缓存 && back返回设置 */
      this.handleBeforeGoCardList();

      this.$router.push({
        path: RouterV2Enum.cardList,
        query: {
          from: FormInfomation.Product,
          commodityId: this.commodityIdChannel,
          capitalCode: this.capitalCode,
          isPreCredit: String(this.channel?.preCredit),
          ocrAfterLoan: String(this.channel?.ocrAfterLoan),
        },
      });
    });
  }

  /** 针对直接访问提现页的场景， history 长度为1，显示 popupview 的时候，实现回退关闭 popup 弹窗的逻辑 */
  private setFirstViewState() {
    // 针对 独立 app 和钱包tab 过来的场景 里面 直接访问提现页的时候，路由记录是1的长度时，显示 popup 时 回退没关闭弹窗 直接关闭页面的场景，加特殊逻辑处理
    // if (window.history.length === 1 && (platform.isSkApp || store.state.base.isHybridAppMode)) {
    if (window.history.length === 1 && platform.isSkApp) {
      if (window.history && window.history.pushState) {
        window.history.pushState({ key: new Date().getTime() }, '', window.location.href);
        // 更新路由
        RouterHelper.updateCurrentState(router.currentRoute.fullPath,
          router.currentRoute.meta.siblingPaths);
        window.addEventListener('popstate', this.backChange.bind(this), false);
      }
    }
  }

  // TODO: remove 事件 为什么会呗监听到
  // 独立app 提现页 回退
  private backChange() {
    if (router.currentRoute.path === RouterV2Enum.applyProduct) {
      // 如果存在 popup 弹窗
      if (PopupView.instance && PopupView.instance.visible) {
        PopupView.close();
      } else {
        // 回到首页
        RouterHelper.backHome();
      }
    }
  }

  private async mounted() {
    /** 预渲染模式下，只显示骨架屏，不执行后续操作 */
    if (IS_PRERENDERING) {
      commonDispatchPreRender();
      /** 删除预渲染内联style样式，实际有用的样式都是link引入 */
      clearNoExpectedNodeInPrerender('style');
      return;
    }
    /** 从url初始化参数: 如recallPreCredit */
    this.initUriQueryContext();

    // 获取防诈骗配置
    this.getAntiFraudConfig();

    /** TODO: 待评估是否可以删除，目前看下来 是可以删掉, 广告系统已经支持弹窗领取功能，可以评估 是否还需要， */
    this.subscribeKMTCP();
    // 链接带（渠道）优惠券 id，更新 store
    if ((this.couponId || this.externalCouponId) && !this.coupon) {
      this.updateApplyProductState(this.couponId ? {
        couponId: this.couponId,
      } : {
        externalCouponId: this.externalCouponId,
      });
      // （渠道）优惠券 id 存在时，重新获取最新优惠券匹配, 不加这个逻辑，优惠券默认选中优惠券名称逻辑会异常
      this.getCouponList();
    }
    if (this.quickBindCardResult && this.getCacheAfterBindCard()) {
      session.set(SessionStorageKeys.BACK_QUICK_BIND__FINAL_RESULT, null);
    } else if (this.h5Bio) {
      const cacheData = this.getCacheAfterH5Bio();

      if (this.sceneType === LivenessSceneEnum.Apply) {
        await livenessPop.getOrderId(
          {
            project: LivenessProjectEnum.ZYQ,
            scene: LivenessSceneEnum.Apply,
          },
          () => this.onSubmitOrderApply('', true, undefined, cacheData?.h5BioLoanApplyMarketReq),
        );
      }

      if (this.sceneType === LivenessSceneEnum.SetPassword) {
        // 设置交易密码
        await this.getTradeKeyToken();
        // 提现
        await this.submitApply();
      }

      /** 交易密码修改场景 TODO: */
      if (this.sceneType === LivenessSceneEnum.ChangePassword) {
        // 密码修改成功
        await this.getTradeKeyToken();

        // TODO: 修改交易密码成功以后，续存逻辑待确定
      }

      /** 未绑卡-活体验证后，重新进入提现流程 */
      if (this.sceneType === LivenessSceneEnum.NoBankCardApplyContract) {
        this.onApplySubmit();
      }

      /** 普通h5（外采&短信用户自己访问）场景，同意提现协议后做活体--继续同意协议 */
      if (this.sceneType === LivenessSceneEnum.ConfirmApplyContract) {
        this.onConfirmApplyContract();
      }
    } else {
      if (this.getInsuranceRelationNo && platform.isHelloApp) {
        this.setDataPlist();
        Toast.allowMultiple(true);
        Toast.loading({
          message: '即将进入密码校验，请勿退出',
          duration: 0,
          forbidClick: true,
        });
        let time = 3;
        this.timeLationNo = setInterval(() => {
          time--;
          if (!time) {
            clearInterval(this.timeLationNo as number);
            Toast.clear();
            closeWebView();
          }
        }, 1000);
        return;
      }

      await this.initApplyProductData();

      // 检查是否展示提额入口（仅自营渠道且未请求过）
      this.checkTempAmountEntryShow();

      if (this.commodityIdChannel) {
        // 获取到默认渠道 id 后，上报渠道 id 信息
        this.$ubtModuleExpose(
          'finance_withdrawalPage_default',
          'commodityId',
          this.commodityIdChannel,
        );
        await this.onCityConfig();

        // 度小满渠道排在第一位，且存在中断订单 强弹的时候，不去调其他渠道的中断订单接口，优先展示度小满弹窗
        if (!this.isVisibleOutstandingOrdersPopup) {
          // 页面初始化时，传入全部渠道 id 列表list，查询用户是否有中断订单
          if (await this.getBrokenStatus({ productIdList: this.channelProductIdList })) {
            this.brokenPop = true;
          }
        }
      }

      const from = this.$route.query && this.$route.query.from;
      // 处理 授信成功跳转到提现页时，提现页回退 回到臻有钱首页的逻辑
      if (from === RouterV2Enum.preApplyResult || from === NewVersionEnum.CREDIT_RESULT) {
        RouterHelper.setBackPath(getHomePath());
      }

      if (!this.getInsuranceRelationNo && platform.isHelloApp && this.isTianchengProductId) {
        this.getDataPlist();
      }

      /** 检查当前用户有无临时额度的下发 */
      this.commonPollingNotifyIssued({
        loopSceneList: [EventLoopNotifySceneEnum.TEMP_AMOUNT],
      });
    }
  }

  // app--plist文件持久化存储的，下次启动还有
  private async setDataPlist() {
    if (isSupportNativeDataStorage()) {
      const relationNo = [];
      relationNo.push(this.getInsuranceRelationNo);
      await nativeLocalSetData({ key: 'finance_applyProductLocal', value: [...relationNo] });
    } else {
      local.set('relationNo', this.getInsuranceRelationNo);
    }
  }

  // app-读取数据
  private getDataPlist() {
    this.timerNumId = setInterval(async () => {
      if (isSupportNativeDataStorage()) {
        const currentRelationNo = await nativeLocalGetData({ key: 'finance_applyProductLocal' }) as string[];
        this.relationNo = Array.isArray(currentRelationNo) ? currentRelationNo.join() : '';
      } else {
        const localRelation = local.get('relationNo') as string;
        this.relationNo = localRelation || '';
      }
      await this.tradeKeyTokenSubmitApply(this.relationNo);
    }, 1000);
  }

  // 甜橙投保逻辑
  private async tradeKeyTokenSubmitApply(relationNo: string) {
    if (this.relationNo) {
      clearInterval(this.timerNumId as number);
      await this.getTradeKeyToken();
      this.submitApply('', false, relationNo);
    }
    // 定位问题
    this.$ubtPageButton('翼支付_投保回溯码', 'relationNo', this.relationNo);
  }

  // app-移除数据
  private async removeData() {
    this.relationNo = '';
    if (isSupportNativeDataStorage()) {
      await nativeLocalRemoveData({ key: 'finance_applyProductLocal' });
    } else {
      local.remove('relationNo');
    }
  }

  /** 初始化定位信息， 当前渠道可用再去调用获取定位配置接口，减少请求, 目前只有3700渠道需要获取定位配置，当前渠道已不合作，后面考虑下线这个代码 */
  private async onCityConfig() {
    if (this.commodityIdChannel && this.channel?.disabled === ChannelDisableEnum.AVAILABLE) {
      await this.getConfigCity({ commodityId: this.commodityIdChannel });
    }
    if (
      this.loanConfigCity
      && this.loanConfigCity.gpsLoanDepend === LoanGpsEnum.M
    ) {
      // 检测app是否开启定位权限
      await checkAndHandleLocationPermission();
    }
  }

  /** 检测产品id是否变更 */
  private get urlParamNotEqualStoreVal() {
    return this.commodityId
        && this.channel
        && this.commodityId !== this.commodityIdChannel;
  }

  private async initApplyProductData() {
    try {
      // 是否存在缓存数据
      const hasChannelAndProduct = this.channel && this.product;
      // 是否指定了产品id且与当前产品不一致
      const isCommodityIdExistAndChange = this.commodityId
        && this.channel
        && this.commodityId !== this.commodityIdChannel;

      if (!hasChannelAndProduct || isCommodityIdExistAndChange) {
        await this.getChannelList({
          productId: this.commodityId || '',
        });


        if (this.channel && this.channel.productId) {
          await this.selectApplyChannel({
            channel: this.channel,
          });
          /** 切换渠道后，更新期数和产品信息 */
          this.getPeriodData(this.amount);
          // 指定了产品id且与当前产品不一致，则更新路由query
          if (this.urlParamNotEqualStoreVal) {
            this.$router.replace({
              query: {
                commodityId: this.channel?.productId,
              },
            });
          }
        }
      }
    } catch (error) {
      // Toast(error.message)
    }
  }

  /** 回退时是否需要展示挽回弹窗 */
  private onBackPopLoad(item:boolean) {
    /** 任何一个弹窗为true以后都不需要重新赋值 */
    if (!this.showBackPop) {
      this.showBackPop = item;
    }
  }

  // 离开页面时显示挽留弹窗
  private beforeRouteLeave(
    to: Route,
    from: Route,
    next: (...d: unknown[]) => void,
  ) {
    this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
      stepDesc: '触发routeLeave',
    });

    // 是否是离开提现页面需要展示挽留弹窗场景
    const isBack = applyPorductIsBackFromRoutes.indexOf(to.path) < 0;

    if (isBack) {
      /**
       * back回退场景，离开提现页时-重置切换渠道挽留弹窗状
       * 确保重新进入提现页(非关闭webview场景)，可以再展示挽留弹窗
       */
      resetSelectChannelRemindPopupControl();
      // 离开提现流程时，重置临额状态
      this.resetTempAmountEntryState();
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发resetSelectChannelRemindPopupControl',
      });
    }

    if (this.$refs.ziyingbRightsTab
      && (this.$refs.ziyingbRightsTab as ZiyingBRightsTab).zhenXiangCardInstance) {
      if ((this.$refs.ziyingbRightsTab as ZiyingBRightsTab).autarkyRetainRightsPopupShow) {
        (this.$refs.ziyingbRightsTab as ZiyingBRightsTab).autarkyRetainRightsPopupShow = false;
      }
      (this.$refs.ziyingbRightsTab as ZiyingBRightsTab).zhenXiangCardInstance.destroyContract();
      // 离开页面时销毁弹窗
      destroyAutarkyRetainRightsPopup();
      destroyCouponDiscountPopup();
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发destroyAutarkyRetainRightsPopup',
      });
    }

    if (this.$refs.superMemberCard as unknown as SuperMemberCardInstance) {
      (this.$refs.superMemberCard as unknown as SuperMemberCardInstance).destroyContract();
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发destroySuperMemberCard',
      });
    }

    if (platform.isHelloApp) {
      this.removeData();
      this.unsubscribeKMTCP();
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发removeData',
      });
    }
    if (this.timerNumId) {
      clearInterval(this.timerNumId as number);
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发clearInterval(this.timerNumId)',
      });
    }
    Toast.clear();
    if (this.timer) {
      clearInterval(this.timer as number);
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发clearInterval(this.timer)',
      });
    }
    /** 如果存在超次手续费协议弹窗 RepaymentRate ，则关闭超次手续费协议弹窗，不进行回退 */
    if (contractPage.isOpen()) {
      contractPage.close();
      RouterHelper.useNextFalse(next);
      return;
    }
    // 如果存在 popup 弹窗（PopupView）
    if (PopupView.instance && PopupView.instance.visible) {
      PopupView.close();
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发PopupView.close',
      });

      if (isBack) {
        this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
          stepDesc: '触发PopupView.close 后 RouterHelper.useNextFalse',
        });
      }
      RouterHelper.useNextFalse(next);
      return;
    }

    // 如果存在 popup 弹窗（popPageManager）
    if (popPageManager.hasOpenedPopPage()) {
      popPageManager.saveOrCloseOpendPop();
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发popPageManager.saveOrCloseOpendPop',
      });
      if (isBack) {
        this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
          stepDesc: '触发popPageManager.saveOrCloseOpendPop 后 RouterHelper.useNextFalse',
        });
      }
      RouterHelper.useNextFalse(next);
      return;
    }

    /** 如果存在提现协议弹窗，则关闭提现协议弹窗，不进行回退 */
    if (this.isVisiblePopUp) {
      this.isVisiblePopUp = false;
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发this.isVisiblePopUp = false',
      });
      if (isBack) {
        this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
          stepDesc: '触发this.isVisiblePopUp = false 后 RouterHelper.useNextFalse',
        });
      }
      RouterHelper.useNextFalse(next);
      return;
    }
    /** 如果存在多资方提现协议弹窗，则关闭多资方提现协议弹窗，不进行回退 */
    if (this.showMultiCapital) {
      this.showMultiCapital = false;
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发this.showMultiCapital = false',
      });
      if (isBack) {
        this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
          stepDesc: '触发this.showMultiCapital = false 后 RouterHelper.useNextFalse',
        });
      }
      RouterHelper.useNextFalse(next);
      return;
    }

    // 关闭权益弹窗
    RightDataDialog.closeDialog();
    this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
      stepDesc: '触发RightDataDialog.closeDialog',
    });
    // 关闭满额提现券弹窗
    if (this.$refs.fullAmountPopRef) {
      (this.$refs.fullAmountPopRef as any).close();
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发(this.$refs.fullAmountPopRef as any).close()',
      });
    }

    // 是否需要重置数据
    this.shouldResetState = [
      String(RouterV2Enum.cardList),
      String(RouterV2Enum.selectedCoupon),
    ].indexOf(to.path) < 0;

    if (
      isBack
      && this.showBackPop
      && !this.isBackDialogVisible
      && this.needShowBackPop
    ) {
      this.isBackDialogVisible = true;
      this.$ubtPageButton('finance_applyProduct_backDialog');
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发this.isBackDialogVisible = true',
      });
      // 移除 自营 B 权益 tab缓存点击 数据
      this.removeRightsData();
      // 关闭弹窗
      this.closeRightsTabPop();
      RouterHelper.useNextFalse(next);
    } else {
      // 关闭可能存在的弹窗
      DialogVant.close();
      Dialog.close();
      const fromSence = this.$route.query && this.$route.query.from;
      this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
        stepDesc: '触发const fromSence = this.$route.query && this.$route.query.from',
      });
      /** 上报back"退出提现页"事件埋点 */
      if (isBack) {
        this.$ubtModuleExposeNew('finance_applyProduct_pageExit');
      }


      // 分发臻享卡事件
      dispatchNotBuyZhenxiangCardEvent({
        pageId: this.$route.meta.pageId,
        clickedSubmitProductIds: this.autrakyZhenxiangCardState?.clickedSubmitProductIds,
        packageType: this.rightParams?.packageType,
        currentProductId: this.commodityIdChannel,
        autrakyNeedBuyZhenxiangCard: this.autrakyZhenxiangCardState?.autrakyNeedBuyZhenxiangCard,
      });

      /**
       * 从授信结果页跳转至提现页回退场景
       * 主要解决问题&问题描述见：https://metis2.hellobike.cn/browse/SKXDZC-5947
       */
      if (isBack && fromSence === `/${NewVersionEnum.CREDIT_RESULT}`) {
        /** 清除from参数 */
        this.$route.query.from = '';
        RouterHelper.backHome();
      } else {
        this.$ubtModuleExposeNew('finance_loan_apply_back_exist_pop', {
          stepDesc: '触发next',
        });
        next();
      }
    }
  }

  private beforeDestroy() {
    window.removeEventListener('popstate', this.backChange.bind(this), false); // false阻止默认事件
    clearInterval(this.timerNumId as number);
    clearInterval(this.timeLationNo as number);
    if (this.shouldResetState) {
      this.$resetState();
      this.$updateState({
        autrakyZhenxiangCardState: {
          clickedSubmitProductIds: [],
          autrakyNeedBuyZhenxiangCard: false,
        },
      });
      this.updateLoanRightState({
        isSuperMemberCheck: null,
        superMemberInfo: null,
      });
    }
    this.updateSuspendFeelTempAmount({ isApplyProductSuspendFeel: false });
    this.unsubscribeKMTCP();
    destroyInstance();
  }

  /** 离开页面时，取消孔明事件订阅，并移除 孔明事件查询定时器 */
  private async unsubscribeKMTCP() {
    if (isSupportKongMingTCP()) {
      // 移除孔明事件轮询定时器
      if (this.kongmingTimer) {
        clearInterval(this.kongmingTimer);
      }

      // 取消事件订阅
      if (this.unsubscribeTCPPageId) {
        await unsubscribeTCP(this.unsubscribeTCPPageId);
      }
    }
  }

  /** 进入页面时 注册订阅孔明事件 并轮询查询
   * TODO: 待评估是否可以删除，目前看下来 是可以删掉, 广告系统已经支持弹窗领取功能，可以评估 是否还需要，
  */
  private async subscribeKMTCP() {
    this.unsubscribeTCPPageId = this.PageId;
    if (isSupportKongMingTCP()) {
      if (this.PageId) {
        this.unsubscribeTCPPageId = this.PageId;
        await subscribeTCP(this.PageId);

        this.kongmingTimer = setInterval(async () => {
          const {
            code, advertId,
          } = await queryEvent(this.PageId);
          if (code === 0 && advertId) {
            await showAdvert(this.PageId, advertId);
          }
        }, 1000);
      }
    }
  }

  /** 切换权益时，联营产品重新调用试算接口* */
  private onRightTabChange(type: SpeedRightsType) {
    // 这里判断非自营的原因
    // 在select-channel组件中监听了selectRightInCapital变化，如果发生变化则会重新获取试算，为规避重复调用，特别增加非自营场景下的特判
    // 优惠券折扣利率实验，在自营24权益单资方场景下，没有资方变化触发试算接口，需要重新调用试算接口
    if (
      (!this.isAutarkyProduct && getPricingTypeByProductId(this.channel?.productId))
      || (this.isCouponLimitExperiment && this.isNeedRightCapitalSinglePassage)
    ) {
      this.calcRepayPlans({
        repayType: repayPlanModelType[this.currentRepayType],
        currentAmount: this.amount,
        notNeedRightRulerCheck: true,
        equitySelected: type === SpeedRightsType.SPEED
          ? EquitySelectedEnum.YES : EquitySelectedEnum.NO,
      });
    }
  }

  /**
   * 检查是否需要在浏览器环境下提示用户打开哈啰APP进行提现
   * @returns 如果需要提示并阻止提交返回 true，否则返回 false
   */
  private checkBrowserAppRedirect(): boolean {
    // 判断当前提现渠道非自营渠道 & 浏览器环境 & 当前渠道定价类型为模式四
    if (
      !this.isAutarkyProduct
      && platform.code === codeEnums.browser
      && getPricingTypeByProductId(this.channel?.productId) === PricingTypeEnum.LOAN_24_MUST_RIGHTS
    ) {
      Toast('请打开哈啰APP进行提现');
      return true;
    }
    return false;
  }

  private async onSubmitClick() {
    /** 将当前产品ID添加到已点击提交的集合中 */
    if (this.commodityIdChannel && this.autrakyZhenxiangCardState) {
      updateClickedSubmitProductIds(this.commodityIdChannel);
    }

    /** 上报"提现-提交"按钮点击事件埋点, 包含渠道id和是否绑定银行卡 */
    this.$ubtPageButtonNew(
      'finance_loan_apply_submitButton',
      {
        productId: this.commodityIdChannel,
        bankCard: this.bankCard ? '1' : '0',
      },
    );
    // 检查是否需要在浏览器环境下是否需要提示用户打开哈啰APP进行提现
    if (this.checkBrowserAppRedirect()) {
      return;
    }
    // 满额提现券弹窗逻辑
    try {
      const fullAmountPopRef = this.$refs.fullAmountPopRef as any;
      if (fullAmountPopRef) {
        const shouldContinue = await fullAmountPopRef.open();
        if (!shouldContinue) {
          // 用户选择了满额提现，停止后续流程
          return;
        }
      }
    } catch (error) {
      ubtSendError(new Error('fullAmountPopRef error'));
    }

    // 提交前，自营 B 有权益的场景逻辑校验，24+单通道普通通道切换到轻资产场景，无需校验
    if (this.needBuyRight && !this.is24NeedRightAndNormalIs36) {
      const rightsTab = this.$refs.ziyingbRightsTab as ZiyingBRightsTab;

      if (rightsTab) {
        // 如果是双承接 & 命中对照组 & 选择普通申请 & 达到限额
        if ((this.isDoublePassagewayPattern || this.isDoublePassagewayPattern24RightsAndPure24)
          && !this.showSpeed) {
          const res = await checkAutarkyLimit({
            productId: this.channel?.productId || '',
            capitalCode: this.selectRightInCapital?.capitalCode || '',
            capitalType: this.selectRightInCapital.rateType || '',
          });
          const checkQuoteLimitRes = this.checkWhenQuoteLimit(res);
          if (!checkQuoteLimitRes) {
            return;
          }
        }

        const {
          isChecked,
          canSubmitOrder,
        } = rightsTab;

        /** 是否需要手动勾选权益 */
        if (canSubmitOrder && !isChecked) {
          this.rightscheckTipsShow = true;
          rightsTab.$el.scrollIntoView({ behavior: 'smooth' });
          return;
        }
      }
    }

    // 超级会员卡片内部逻辑处理内聚，用于超级会员前置流程判断
    if (this.$refs.superMemberCard) {
      await (this.$refs.superMemberCard as unknown as SuperMemberCardInstance).checkBuy();
    }
    /** 用户点击"提现-提交"按钮之后，不再感知更新的临额信息，干扰用户主流程 */
    this.updateSuspendFeelTempAmount({ isApplyProductSuspendFeel: true });

    /**
     * 表单输入项进行校验
     * */
    if (!this.formValidatorsResult()) return;
    if (this.timerNumId) {
      clearInterval(this.timerNumId as number);
    }
    if (
      this.loanConfigCity
      && this.loanConfigCity.gpsLoanDepend === LoanGpsEnum.M
    ) {
      const locationIsOpen = await checkIsOpenGPS();
      // 检测app是否开启定位权限，开启成功以后，再进行提交
      if (locationIsOpen) {
        this.checkBeforeSubmit();
      }
    } else {
      this.checkBeforeSubmit();
    }
  }

  private async checkBeforeSubmit() {
    // check 逻辑统一封装，解决当需要校验 GPS 场景的渠道，未 check 中断订单的 bug
    // 提交提现订单时，查看是否有中断订单, 此时查询的是当前选中渠道是否有订单
    const brokenRes = await this.getBrokenStatus({ productId: this.commodityIdChannel });
    if (!brokenRes) {
      this.onApplySubmit();
    } else {
      this.brokenPop = true;
    }
  }

  private onChangeFraudState() {
    this.isVisibleFraudPopUp = false;
    this.hasShownFraudPopUp = true;
  }

  /** 获取当前权益卡片数据 */
  private getCurrentRightParams() {
    // 获取超级会员卡片实例
    const superMemberCardRef = this.$refs.superMemberCard as unknown as SuperMemberCardInstance;

    // 获取超级会员卡片内部参数
    let rightParams = superMemberCardRef ? superMemberCardRef.getRightSumbitParams() : null;

    // 如果 getRightSumbitParams() 返回的结果不为null，说明该用户命中了超级会员场景
    // 否则，继续判断是否命中臻享卡权益
    // 此处兼容无需购买臻享卡权益
    if (!rightParams) {
      rightParams = formatZhenXiangCardParams(
        this.rightParams,
        this.isCountingDownFinished,
        this.getRightEquatyValue(),
        getPricingTypeByProductId(this.channel?.productId),
      );
    } else {
      rightParams = {
        ...rightParams,
        pricingType: getPricingTypeByProductId(this.channel?.productId),
      };
    }
    return rightParams;
  }

  private async doCheckRightParams(): Promise<boolean> {
    try {
      // 24+单通道普通通道切换到轻资产场景，无需执行此校验逻辑
      if (this.is24NeedRightAndNormalIs36) {
        return true;
      }

      const checkEquityValueRes = checkEquityValue(
        this.getRightEquatyValue(),
        this.getCurrentRightParams(),
        getPricingTypeByProductId(this.channel?.productId),
      );
      const periodVal = this.period?.period;

      /** 默认为true,校验通过 */
      let checkParamsMatchRes = true;
      /** 针对需要购买臻享会员的无需check 档位信息 */
      if (this.needBuyRight && this.needBuyZhenxiangCard) {
        checkParamsMatchRes = checkParamsMatch(
          { amount: Number(this.amount), period: periodVal ? Number(periodVal) : 0 },
          this.getCurrentRightParams(),
        );
      }

      // 如果需要购买臻享会员卡，保证档位信息匹配
      let checkTypeMatchRes = true;
      if (this.needBuyZhenxiangMember
          && this.channel?.productId === ProductCommodity.AUTARKY_B_COMMODITY) {
        checkTypeMatchRes = checkPackageType(
          this.getCurrentRightParams(),
          RightPackageTypeEnum.ZHEN_XIANG_MEMBER_CARD,
        );
        // 如果不匹配重新查询一次
        if (!checkTypeMatchRes) {
          await store.dispatch('loanRight/getRightSummaryData');
          this.$ubtModuleExposeNew('finance_loan_rightsCheck_monitor', {
            action: 'zhenXiangCard_is_not_match',
          });
        }
      }

      // 增加埋点，用于后续分析
      this.$ubtModuleExposeNew('finance_loan_rightsCheck_monitor', {
        checkEquityValueRes: String(checkEquityValueRes),
        checkParamsMatchRes: String(checkParamsMatchRes),
        checkTypeMatchRes: String(checkTypeMatchRes),
      });

      if (!checkEquityValueRes || !checkParamsMatchRes) {
        RightDataDialog.showDialog(
          RightTipsDialogSceneEnum.LOAN_RIGHT_PARAMS_ERROR_AND_CATCH,
          RightTipsDialogActionEnum.REFRESH_PAGE,
          () => {
            window.location.reload();
          },
        );
        return false;
      }
      return true;
    } catch (e) {
      // 增加埋点，用于后续分析
      this.$ubtModuleExposeNew('finance_loan_rightsCheck_monitor', {
        errorInfo: 'catchError',
      });
      // 进入error,默认校验通过，不卡住提现流程
      return true;
    }
  }


  // 提交订单
  private async onApplySubmit() {
    // 这种增加权益极端异常场景兜底，调用环节比较前置，是为了防止用户做了一系列操作后，但是最终下不了单的情况，或者逻辑产生异常
    if (!await this.doCheckRightParams()) {
      ubtSendError('checkRightsParamsError');
      return;
    }

    // 未绑卡，则走新的绑卡流程（银河渠道排除，不做处理）
    if (!this.bankCard && !this.isAlipayType) {
      this.setCacheBeforeH5Bio();
      if (this.channel?.preCredit) {
        await this.preCreditBeforeEnterApplyCheck();
      } else {
        if (this.channel?.ocrAfterLoan) {
          await checkBindCardNeedVerify(
            [this.commodityIdChannel],
            {
              type: VerifyQueryParamsTypeEnum.ApplyForNoBankCard,
            },
          );
        } else {
          // 检测用户资料是否填写完整
          await this.checkOuterChannel({
            commodityIds: [this.commodityIdChannel],
            isApplyNoBankCard: true,
          });
        }
      }

      (this.$refs.selectBankcardRef as SelectBankcard).goSelectPage();
      return;
    }

    /** s2002事件检测，中断提现流程 */
    try {
      await loanOrderCheck({ productId: this.commodityIdChannel });
    } catch (error) {
      const errCode = Number((error as { code: string }).code || 0);

      /** 若是渠道检测不准入，则中断提现流程 */
      if (errCode === ResponseCodeEnum.LOAN_ORDER_CHECK_REJECT) {
        return;
      }

      ubtSendError(error as Error);
    }

    // 是否触发诈骗弹窗
    const { showFraudPopUp } = this.antiFraudConfig || {};
    if (!this.hasShownFraudPopUp && showFraudPopUp) {
      this.isVisibleFraudPopUp = true;
    } else {
      this.onFraudConfirm();
    }
  }

  // 触发诈骗弹窗confirm事件后，才会走提现后续流程
  private async onFraudConfirm() {
    if (this.getContractInfo) {
      session.set('applyProductForm', {
        productId: this.commodityIdChannel,
        bankCardId: (this.bankCard && this.bankCard.bankId) || '',
        amount: this.amount,
        period: this.period ? this.period.value : '',
        usage: this.usage ? this.usage.name : '',
        repaymentModel: this.repaymentModel || '',
      });
      if (isNewYhChannel(this.commodityIdChannel) && this.amount) {
        await this.getNewYHConstracts();
      }

      // 支付宝类型 才走签约
      if (this.isYhProductId && this.isAlipayType) {
        await this.checkAlipayStatus();
        if (!this.iSalipaySignSuccess) {
          Toast('请您先完成支付宝签约');
          return;
        }
      }
      // 支付宝类型 才走签约
      if (this.isAlipayMiniCommodity && this.isAlipayType) {
        const params = {
          scene: SceneTypeEnum.LOAN,
          creditApplyId: this.channel && this.channel.creditApplyId,
        };
        await this.checkAlipay(params);
        if (!this.getAlipayStatus) {
          Toast('请您先完成支付宝签约');
          return;
        }
      }
    }

    const { packageType } = this.getCurrentRightParams() || {};
    // 调用通联绑卡协议
    const allinpayAuthCheckRes = await doAllinpayAuth({
      productId: this.commodityIdChannel,
      tqParams: { capitalCode: this.capitalCode, packageType },
      bankCardId: (this.bankCard && this.bankCard.bankId) || '',
      equityTick: this.isRightChecked,
      pricingType: getPricingTypeByProductId(this.channel?.productId),
    });

    // 通联绑卡验证不通过，不继续执行下方操作
    if (allinpayAuthCheckRes) {
      this.$ubtPageButtonNew(
        '臻有钱_提现申请_提交',
        {
          flagType: 'commodityId',
          flagValue: this.commodityIdChannel,
          equityPathType: String(this.getRightEquatyValue()),
          capitalCode: this.capitalCode,
          repaymentMode: this.repayOnSchedule ? '按期还' : '灵活还',
          amount: this.amount,
          maxAmount: this.maxAmount,
          fullLoanAmountCoupon: this.coupon?.ruleInfo?.fullLoanAmount || false,
          couponId: this.coupon && this.coupon.couponId,
          period: this.period && this.period.value,
          /** 银行卡相关信息 */
          ...getBankCrucialInfo(this.bankCard),
          /** 本次使用的临时额度金额 */
          snapQuotaAmount: getSnapQuotaAmount(this.channel, this.amount),
          ...getDoubleModeCommonUbtParams(this.channelList),
          /** 是否24+权益单通道切换普通通道使用轻资产承接场景 */
          isRightAndAutarkyChangelight: this.is24NeedRightAndNormalIs36,
        },
      );

      // 获取协议列表
      await this.getContractLoan(this.loanContractForm as LoanAgreementPO, ContractEnum.APPLY);

      if (this.channel && this.channel.routeMarket === RouteMarketEnum.SERIAL) {
        this.showMultiCapital = true;
      } else {
        this.isVisiblePopUp = true;
      }
    }
  }

  private get isAutarkyProduct() {
    return this.channel?.productId === ProductCommodity.AUTARKY_B_COMMODITY;
  }

  private getRightEquatyValue(): EquityPathType {
    // 如果自营权益权益未挂载则传2，标识无需购买，联营传''保持逻辑一致
    let equatyValue = this.isAutarkyProduct
      ? EquityPathType.NOT_NEED_RIGHT : EquityPathType.NONE;

    // 如果权益视图挂载，表明需要购买权益，则取视图内部的值
    if (this.$refs.ziyingbRightsTab as ZiyingBRightsTab) {
      equatyValue = (this.$refs.ziyingbRightsTab as ZiyingBRightsTab).equatyValue;
    }

    // 24+单通道普通通道切换到轻资产场景，提现流程传参数需兼容
    if (this.is24NeedRightAndNormalIs36) {
      return EquityPathType.NOT_NEED_RIGHT;
    }

    return equatyValue;
  }

  /** 诈骗弹窗确认受引导后，关闭弹窗停留在提现页 */
  private onClosedFraudPopup() {
    this.isVisibleFraudPopUp = false;
  }

  // 表单校验
  private formValidatorsResult() {
    const errMsg = this.formValidators.reduce(
      (_errMsg, validator) => _errMsg || validator(),
      '',
    );

    const calcResultStatus = (
      this.planListData && this.planListData.calcResult === ReplanResultType.REPLAN_FAILED
    ) || !this.planListData;

    // 对必填字段进行验证
    if (errMsg || calcResultStatus) {
      Toast(errMsg || '还款计划计算失败，您可尝试退出重新进入当前页面');
      return false;
    }
    return true;
  }

  // 新银河协议
  private async getNewYHConstracts() {
    const loanContractForm: LoanAgreementPO = await ContractApi.loanAgreementParms({
      commodityId: platform.isAlipayMini ? Number(ALIPAYMINI_COMMODITY)
        : Number(NEW_YINHE_COMMODITY),
      applyAmount: this.amount,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      applyPeriod: (this.period && this.period.value)!,
      repaymentModel: RepayMentModelType[this.repaymentModel] || RepaymentModel.EPAI,
      creditApplyId: this.channel && this.channel.creditApplyId,
    });
    this.loanContractFormBak = loanContractForm;
    session.set('loanContractForm', loanContractForm);
  }

  // 获取提现申请协议
  private async getContractLoan(constractItem: LoanAgreementPO, remarkType: string) {
    // 获取协议列表
    if (this.channel && this.channel.routeMarket === RouteMarketEnum.SERIAL) {
      await this.multiCapitalContracts();
    } else {
      let showAllinPayContract = false;
      // 根据超级会员的勾选状态来判读是否展示通联绑卡协议
      if (this.$refs.superMemberCard && (
        this.$refs.superMemberCard as unknown as SuperMemberCardInstance
      ).getRightSumbitParams()) {
        showAllinPayContract = true;
      }
      /**
       * 当命中授用信一体化实验组
       * 同步获取8180授信协议无需等待结果返回，不能影响提现流程
      */
      if (this.isExperimentAB) {
        this.getAutarkyAgreements();
      }
      await this.getContracts(Object.assign(constractItem, { remarkType, showAllinPayContract }));
    }
  }

  // 获取交易密码
  private async getTradeKeyToken() {
    const commodityId = this.commodityIdChannel;
    this.updateApplyProductState({
      tradePasswdToken: await TradeKey.getToken({
        commodityId,
      }),
    });
  }

  // 度小满强弹协议弹窗提交订单
  private async onForceReadBtn() {
    if (this.forceReadContract) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const { applyOrderCheckVo: applyCheck } = this.submitResult;
      if (!applyCheck.contractAdd) {
        if (!applyCheck.sms) {
          // 输入验证码验证
          this.showSmsDialog = true;
        } else if (!applyCheck.faceCheck) {
          // 活体识别
          this.$ubtModuleExpose(
            '臻有钱_提现申请_下单前检测_活体识别',
            'commodityId',
            this.commodityIdChannel,
          );
          await livenessPop
            .getOrderId({
              scene: LivenessSceneEnum.Apply,
              project: LivenessProjectEnum.ZYQ,
              commodityId: this.commodityIdChannel,
            })
            .then(() => {
              // 非h5活体场景，提交
              if (!(platform.isDingTalk || isH5App)) {
                this.submitApply('', true);
              }
            })
            .catch((err) => {
              // eslint-disable-next-line no-console
              console.error('h5活体失败 臻有钱_提现申请_下单前检测_活体识别', err);

              // 非h5活体场景，提交
              if (!(platform.isDingTalk || isH5App)) {
                this.updateApplyProductState({
                  checkType: '',
                });
              }
              // 失败会自动显示toast，或者 手动返回
            });
        } else {
          this.submitApply('', true);
        }
      } else {
        this.submitApply();
      }
    } else {
      // 提交订单
      this.submitApply();
    }
  }

  // 提现协议弹窗-确认协议所有协议
  private async onConfirmApplyContract(confirmedContractCallback?: () => void) {
    // 提现申请同意协议节点，上报协议同意行为（不 await，不影响后续流程）
    reportAgreementAgree({
      capitalCode: this.capitalCode,
      productId: this.commodityIdChannel,
    }).catch(() => { /* 上报失败不影响后续流程 */ });

    /** 判断还款计划计算是否失败 在提交协议弹窗时做校验目的是
     * 防止用户在试算接口debounce期间快速点击提交按钮之后 用上一次的试算数据拉起提现弹窗
     * 详细见 https://hellobike.yuque.com/gpxxgb/oyyz8n/gdg4b2wyti1vsyhm
     * */
    const calcResultStatus = (
      this.planListData && this.planListData.calcResult === ReplanResultType.REPLAN_FAILED
    ) || !this.planListData;

    if (calcResultStatus) {
      Toast('还款计划计算失败，您可尝试退出重新进入当前页面');
      ubtSendError('calc_error_but_withdraw_pop_and_apply_submit');
      return;
    }

    this.setCacheBeforeH5Bio();
    // 检测用户资料是否填写完整
    await this.checkOuterChannel({
      commodityIds: [this.commodityIdChannel],
      isPreCredit: this.channel ? this.channel.preCredit : false,
      ocrAfterLoan: this.channel?.ocrAfterLoan || false,
    });

    // 提现是否需要补充资料校验
    const fields = await supplyNeedConfig([this.commodityIdChannel], SceneTypeEnum.LOAN);
    const supplyValidFields = fields.filter((name) => name !== 'id');
    /** 需要补充资料 */
    if (supplyValidFields && supplyValidFields.length) {
      // 其他情况用补充资料组件
      jumpToVerifyCredit(VerifySceneEnum.LOAN_SUPPLY_PERSONAL, {
        commodityIds: [this.commodityIdChannel],
        useReplace: true,
        openMode: OpenVerifyPageMode.POPUP_SHOW,
        successCb: async () => {
          this.$ubtPageButton('臻有钱_提现申请_补充资料页');

          const { insure, insureForwardUrl } = this.planListData;

          if (insure) {
            this.getDataPlist();
            openThirdPage(insureForwardUrl);
            return;
          }

          // 判断是否需要输入交易密码
          if (this.needTradePasswd) {
          // 设置交易密码
            this.setCacheBeforeH5Bio();
            await this.getTradeKeyToken();
          }
          // 提交订单
          this.submitApply();
        },
        failCb: (error) => {
        // 出现异常或者用户执行了返回: 执行返回的时候 error 返回 undefined
          this.$ubtPageButton(
            `臻有钱_提现申请_补充资料页_${!error ? '取消' : '失败'}`,
          );
        },
      });
    } else {
      /** TODO:// 不需要补充资料 无需要曝光 */
      this.$ubtPageButton('臻有钱_提现申请_补充资料页');

      const { insure, insureForwardUrl } = this.planListData;

      if (insure) {
        this.getDataPlist();
        openThirdPage(insureForwardUrl);
        return;
      }

      // 判断是否需要输入交易密码
      if (this.needTradePasswd) {
      // 设置交易密码
        this.setCacheBeforeH5Bio();
        await this.getTradeKeyToken();
      }
      // 提交订单
      this.submitApply();
    }
    /** TODO: 回退关闭 popup 逻辑注入，新版弹窗场景，待完善  */
    setTimeout(() => {
      if (PopupView.instance && PopupView.instance.visible) {
        this.setFirstViewState();
      }
    }, 250);
    /** 执行用户确认同意协议之后的回调方法 */
    if (typeof confirmedContractCallback === 'function') {
      confirmedContractCallback();
    }
  }

  // 针对提现协议弹窗-确认协议所有协议的节流
  private onThrottleConfirmApplyContract = throttle(this.onConfirmApplyContract.bind(this), 1500, {
    trailing: false,
  });

  // 当前卡是否最新
  private async currentBank() {
    const commodityId = String(this.commodityIdChannel);
    const { capitalCode } = this;
    this.cardBankList = await SelectCardApi.getSelectCardList({
      cardType: 0,
      commodityId,
      capitalCode,
    });

    if (this.cardBankList.length) {
      const currentBank: SelectCardInfo[] = this.cardBankList.filter(
        (item) => (this.bankCard && item.id === this.bankCard.bankId),
      );

      return currentBank.length ? currentBank[0] : {};
    }

    return {};
  }

  private checkWhenQuoteLimit(res: AutarkyLimitReturnType) {
    const rightsTab = this.$refs.ziyingbRightsTab as ZiyingBRightsTab;
    const { result, buttonName, clickType } = res;
    if (!result && rightsTab) {
      this.$ubtPageButtonNew('fincance_loan_normalapply_limitPopup_click', {
        buttonName,
      });
      if (clickType === ClickTypeEnum.CHANGE_CHANNEL) {
        rightsTab.zhenXiangCardInstance.onTabChange(SpeedRightsType.SPEED);
      }
      return false;
    }
    return true;
  }

  // 提交下单申请
  // eslint-disable-next-line consistent-return
  private async submitApply(smsCode?: string, lastApplyResult?: boolean, relationNo?: string) {
    this.updateApplyProductState({
      lastApplyResult,
    });

    const { bankCard } = this;
    const productId = this.commodityIdChannel;

    if (this.isAlipayType) {
      // 下单
      this.onSubmitOrderApply(smsCode);
    } else {
      // 查询当前卡在渠道方银行列表是否绑定
      await this.takeBankCardIsUsed({
        productId,
        userBankCardId: (bankCard && bankCard.bankId) || '',
      });
      if (this.isBankCardUsed.isBind) {
        // 针对自营 B 多资方 二次绑卡场景，不去校验当前银行卡是否绑定, （长银资方，先和通联绑定，再和长银绑定）
        if (!this.capitalCode) {
          const currentForm = (await this.currentBank()) as SelectCardInfo;
          if (!currentForm.isBind) {
            this.onBankCardBindDialogShow();
            // eslint-disable-next-line consistent-return
            return false;
          }
        }


        // 下单
        this.onSubmitOrderApply(smsCode, lastApplyResult, relationNo);
      } else {
        this.onBankCardSelectDialogShow();
      }
    }
  }

  // 提现下单
  private onSubmitOrderApply(
    smsCode?: string,
    lastApplyResult?: boolean,
    relationNo?: string,
    loanApplyMarketReq?: LoanApplyMarketReqType,
  ) {
    const {
      channel,
      capitalCode,
    } = this;
    const { couponId, externalCouponId } = this.getDefaultCoupon || {};

    this.submitOrderApply({
      smsCode: smsCode || '',
      defaultCouponId: couponId || '',
      defaultExternalCouponId: externalCouponId,
      lastApplyResult,
      insuranceRelationNo: relationNo as string,
      creditApplyId: channel && channel.creditApplyId,
      capitalCode,
      loanApplyMarketReq: loanApplyMarketReq || this.getCurrentRightParams() || undefined,
    }).catch(async (error) => {
      const errCode = Number(error.code || 0);
      // 交易密码错误
      if (
        [
          ResponseCodeEnum.PASSWORD_TOKEN_IS_ERROR,
          ResponseCodeEnum.PASSWORD_TOKEN_IS_NULL,
        ].indexOf(errCode) >= 0
      ) {
        // 清除接口异常Toast，否则Toast会盖在Dialog上面
        Toast.clear();
        const tradeErrMessage = error && (error.message || error.msg);
        this.onTradePasswordDialogShow(tradeErrMessage);
      } else if (
        [
          ResponseCodeEnum.ORDER_CHECK_ERROR,
          ResponseCodeEnum.REMIT_FAILD,
        ].indexOf(errCode) >= 0
      ) {
        Toast.clear();
        this.goResultPage();
      } else if ([
        ResponseCodeEnum.CANNOT_ORDER_AGAIN].indexOf(errCode) >= 0
        && this.forceReadContract
      ) {
        Toast.clear();
        this.goResultPage();
      } else if (errCode === ResponseCodeEnum.RIGHT_PARAMS_ERROR) {
        // errorCode表示权益入参不正确，弹窗提示
        RightDataDialog.showDialog(
          RightTipsDialogSceneEnum.LOAN_RIGHT_PARAMS_ERROR,
          RightTipsDialogActionEnum.REFRESH_PAGE,
          () => {
            window.location.reload();
          },
        );
      } else if (errCode === ResponseCodeEnum.LOAN_ORDER_CHECK_FUND_ROUTE_ID) {
        // 资金路由ID重复，刷新重试
        Toast({
          message: '操作频繁，请稍后再试',
          onClosed: () => {
            window.location.reload();
          },
        });
      } else if (errCode === ResponseCodeEnum.AUTARKY_QUOTE_LIMIT) {
        // 清除接口异常Toast，否则Toast会盖在Dialog上面
        Toast.clear();
        // 命中自营b限额展示限额弹窗
        const res = await showAutarkyLimitDialog();
        this.checkWhenQuoteLimit(res);
      } else {
        throw new Error(error && error.message);
      }
    });
  }

  // 针对下单结果进行分析处理
  @Watch('submitResult')
  private async onSubmitResultChange(newValue: SubmitApplyResultData, old: SubmitApplyResultData) {
    // 状态数据被重置的情况
    if (!this.submitResult) {
      return;
    }
    const {
      loanOrderId, applyOrderCheckVo: applyCheck, loanWait, orderStuck,
    } = this.submitResult;
    const { postPositionSms } = applyCheck || {};

    // 中断订单情况, submitResult 的 loanOrderId 会被赋值，需要判断 applyCheck 是否有值，再往下走流程
    if (!applyCheck) {
      return;
    }

    if (!applyCheck.userInfo) {
      // 用户姓名不符合规范
      this.showCheckUserInfoDialog();
    } else if (!applyCheck.wait) {
      this.updateApplyProductState({
        checkType: applyCheck.wait ? '' : 'wait',
      });
      this.currentVisiblePopup = true;
    } else if (!applyCheck.contractAdd && applyCheck.contractType) {
      await this.getContractLoan(this.loanContractForm as LoanAgreementPO, applyCheck.contractType);
      this.isVisibleForcePopup = true;
    } else if (!applyCheck.alipayWithholdCheck) {
      // 银河支付宝签约检测
      Toast('请您先完成支付宝签约');
    } else if (!applyCheck.sms) {
      // 输入验证码验证
      this.showSmsDialog = true;
    } else if (!applyCheck.faceCheck) {
      // 活体识别
      this.$ubtModuleExpose(
        '臻有钱_提现申请_下单前检测_活体识别',
        'commodityId',
        this.commodityIdChannel,
      );

      this.setCacheBeforeH5Bio();

      await livenessPop
        .getOrderId({
          scene: LivenessSceneEnum.Apply,
          project: LivenessProjectEnum.ZYQ,
          commodityId: this.commodityIdChannel,
        })
        .then(() => {
          // 非h5活体场景，提交
          if (!(platform.isDingTalk || isH5App)) {
            this.submitApply('', true);
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error('提现提交 做活体h5场景 ', err);
          if (!(platform.isDingTalk || isH5App)) {
            this.updateApplyProductState({
              checkType: '',
              checkId: '',
            });
            // 失败会自动显示toast，或者 手动返回
          }
        });
    } else if (!applyCheck.idCardExpiredCheck) {
      /** 此场景线上理应无流量，若存在则异常上报，进行链路排查 */
      ubtSendError('withdraw order submission should not appear id-card expired');
    } else if (loanWait) {
      // 度小满-二次查询协议弹窗
      this.currentVisiblePopup = true;
      // 关闭短信弹窗
      this.showSmsDialog = false;
    } else if (loanOrderId && !postPositionSms) {
      this.showSmsDialog = true;
      this.smsSceneType = SmsSceneType.BROKEN;
    } else if (applyCheck.smsCheckError === '1') {
      Toast(applyCheck.errMsg || '未知错误,请重试');
      // eslint-disable-next-line consistent-return
      return false;
    } else if (orderStuck) {
      /** 24资方权益卡单订单，命中跳转权益卡单页 */
      this.$router.replace({
        path: RouterV2Enum.withdrawalWaiting,
        query: {
          ...this.$route.query,
          loanOrderId,
          capitalCode: this.channel?.capitalList[0]?.capitalCode || '',
        },
      });
    } else {
      // 监听的前后数据一致时，不重复走流程，避免多次跳转
      if (newValue === old) {
        return;
      }
      this.goResultPage(loanOrderId);
    }
  }

  /** 显示用户姓名验证不通过确认弹窗，引导用户修改用户姓名--20251119确认，无该场景，后续考虑删除代码 */
  private showCheckUserInfoDialog() {
    this.$ubtPageButton('臻有钱_提现申请_姓名不符合规则');

    Dialog.confirm({
      title: '姓名不符合规则',
      message: '联系人姓名仅支持2个汉字及以上,请修改后再发起提现',
      cancelButtonText: '取消',
      confirmButtonText: '前往修改',
      closeable: false,
    })
      .then(() => {
        this.$ubtPageButton(
          '臻有钱_提现申请_前往修改',
          '产品',
          this.commodityIdChannel,
        );

        jumpToVerifyCredit(VerifySceneEnum.PERSONAL_NAME_MODIFY, {
          queryParams: {
            from: 'product',
          },
        });
      })
      .catch(() => {
        this.$ubtPageButton(
          '臻有钱_提现申请_取消',
          '产品',
          this.commodityIdChannel,
        );
      });
  }

  // 短信验证码弹窗关闭
  private hideSmsDialog() {
    // 不做渠道限制，全渠道进行回归测试checkId场景
    this.updateApplyProductState({
      checkType: '',
      checkId: '',
    });

    this.showSmsDialog = false;
  }

  private onSendApplySms() {
    this.$ubtPageButton(
      '臻有钱_提现申请_获取验证码',
      '产品',
      this.commodityIdChannel,
    );

    this.sendApplySms(this.smsSceneType);
  }

  private async onSubmitSmsCode(smsCode: string) {
    this.$ubtPageButton(
      '臻有钱_提现申请_短信弹窗确认提交',
      'commodityId',
      this.commodityIdChannel,
    );

    this.updateApplyProductState({
      smsCode,
    });

    /** 5000 同程金融不合作 -2025-11-24 确认 */
    if (this.commodityIdChannel === TONGCHENG_COMMODITY) {
      this.hideSmsDialog();
    }
    // 已经生成了订单，则直接对短信验证码进行验证即可；否则需要携带smsCode并重新提交订单
    if (this.submitResult && this.submitResult.loanOrderId) {
      // 这个场景 可以使用分期乐来验证，很多老渠道已经不合作了；目前线上只有分期乐这一个渠道是这个逻辑分支；
      /** 3200 分期乐 已不合作 -2025-11-24 确认 */
      try {
        const confirmResult = await this.confirmApplySms({
          smsCode,
          smsSceneType: this.smsSceneType,
        });

        if (this.smsSceneType === SmsSceneType.BROKEN && confirmResult) {
          this.goResultPage(this.submitResult.loanOrderId);
          return;
        }

        if (confirmResult.result) {
          this.$ubtPageButton(
            '臻有钱_提现申请_短信验证码提交成功',
            'commodityId',
            this.commodityIdChannel,
          );

          this.goResultPage(confirmResult.loanOrderId);
        } else {
          Toast('验证码输入错误，请重试');
        }
      } catch (error: any) {
        this.$ubtPageButton(
          '臻有钱_提现申请_短信验证码提交失败',
          'commodityId',
          this.commodityIdChannel,
          '失败原因',
          error && error.message,
        );
      }
    } else {
      this.submitApply(smsCode);
    }
  }

  private onTradePasswordDialogShow(message: string) {
    Dialog.alert({
      title: '交易密码失败',
      message,
      closeable: false,
      confirmButtonText: '输入交易密码',
    }).then(async () => {
      await this.getTradeKeyToken();
      this.$ubtPageButton('臻有钱_交易密码过期_输入交易密码');
      this.submitApply();
    });
  }

  /** 自营B 购买臻享权益 */
  private buyRightOrNot(): boolean {
    if (this.$refs.ziyingbRightsTab as ZiyingBRightsTab) {
      const { equatyValue } = this.$refs.ziyingbRightsTab as ZiyingBRightsTab;
      return equatyValue === EquityPathType.BUY_RIGHTS;
    }
    return false;
  }

  /** 臻享卡或者超级会员是否勾选 */
  private get isRightChecked(): boolean {
    // 如果展示了臻享卡
    if (this.needBuyRight) {
      const rightsTab = this.$refs.ziyingbRightsTab as ZiyingBRightsTab;
      // 展示了臻享卡的卡片 & 选择购买的情况，传递勾选值
      if (rightsTab && this.buyRightOrNot()) {
        const { isChecked } = rightsTab;
        return isChecked;
      }
      // 展示臻享卡，选择了普通申请，传递勾选情况为false
      return false;
    }
    if (this.$refs.superMemberCard) {
      return (this.$refs.superMemberCard as unknown as SuperMemberCardInstance).check;
    }
    return false;
  }

  /** 移除 自营 B 权益 tab缓存点击 数据 */
  private removeRightsData() {
    const rightsTab = this.$refs.ziyingbRightsTab as ZiyingBRightsTab;
    if (rightsTab) {
      this.updateLoanRightState({
        isRightTick: false,
        showSpeed: false,
        rightParams: null,
      });
    }
  }

  // 挽留弹窗弹出场景 先 关闭权益购买场景的弹窗
  private closeRightsTabPop() {
    const rightsTab = this.$refs.ziyingbRightsTab as ZiyingBRightsTab;
    if (rightsTab) {
      // 挽留弹窗弹出场景 先 关闭权益购买场景的弹窗
      rightsTab.onClosedRightsPopup();
    }
  }

  /**
   * 生成提现订单后跳转到结果页
   * 1. 在钉钉移动端浏览器且是安卓或鸿蒙，路由push跳转申请结果页
   * 2. （非钉钉）当前页是第一个页面（落地页），路由push跳转申请结果页
   * 3. （非钉钉）当前页非第一个页面，路由replace跳转申请结果页
  */
  private goResultPage(orderId?: string) {
    let query: Dictionary<string> = {
      orderId: String(orderId) || '',
      commodityId: String(this.commodityIdChannel),
      commodityName: this.commodityNameChannel,
    };

    // 只有当 pricingType 不为 undefined 时才添加到 query 中
    const pricingType = getPricingTypeByProductId(this.channel?.productId);
    if (pricingType) {
      query.pricingType = String(pricingType);
    }

    // 如果金融权益生效中
    if (this.submitResult && this.submitResult.equityEffect) {
      query = {
        ...query,
        // 标识是否是金融vip生效中用户
        financeVipType: String(this.submitResult.packageType),
      };
    }

    // fix 17523
    if (platform.isDingTalk && (platform.isAndroid || platform.isHarmony)) {
      this.$ubtModuleExposeNew('finance_loan_apply_success_return', {
        scene: GoResultSceneType.APPLYRESULT_ISDINGTALK,
      });
      this.$router.push({
        path: RouterV2Enum.applyResult,
        query,
      });
    } else {
      // 提现订单发起成功，有订单 id, 说明提现订单生成成功了
      if (orderId) {
        // 下单跳转前，移除 权益tab缓存数据 -- 移除 自营 B 权益 tab缓存点击 数据
        this.removeRightsData();
      }

      if (window.history.length === 1) {
        this.$ubtModuleExposeNew('finance_loan_apply_success_return', {
          scene: GoResultSceneType.APPLYRESULT_ISFIRST,
        });
        // 解决直接访问提现页，提现失败页 beforeRouterLeave不生效的问题, 补充资料场景 长度是2，其他场景长度是1
        this.$router.push({
          path: RouterV2Enum.applyResult,
          query,
        });
      } else {
        this.$ubtModuleExposeNew('finance_loan_apply_success_return', {
          scene: GoResultSceneType.APPLYRESULT,
        });
        this.$router.replace({
          path: RouterV2Enum.applyResult,
          query,
        });
      }
    }
  }
}
